import { api } from "./api";

export const getTecnicos = () => {
    return api.get("/tec");
};
  
export const createTecnico = async (body) => {
    return api.post("/tec/register", body)
}

export const editTecnico = async (body) => {
    return api.put("/tec/updt", body);
}

export const deleteTecnico = async (id) => {
    return api.delete(`/tec/del/${id}`, )
}
  